const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Amara",

  // not sure if amara webfeed is active on client site
  webfeedDebuggerWebsiteUrl: "https://avid.com.au/villaworld-homes#/feed",
  webfeedConfig: {
    mode: "masterplan", // masterplan, feed
    type: "land" // land, packages, dwellings etc
  }
  // add other conf items below if needed
};
